/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SwapIcon = /*#__PURE__*/ createSvgIcon(
  'SwapIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.504 11a.734.734 0 01-.535-.216.72.72 0 01-.22-.534V4.875L5.084 6.542a.733.733 0 01-1.062 0 .733.733 0 010-1.063l2.958-2.958a.756.756 0 01.525-.208c.1 0 .194.017.281.052a.691.691 0 01.236.156l2.958 2.958c.153.153.23.327.23.521a.75.75 0 01-.23.53.745.745 0 01-1.063-.01L8.25 4.876v5.375c0 .213-.072.39-.215.534a.72.72 0 01-.53.216zm4.992 6.688a.756.756 0 01-.282-.053.69.69 0 01-.235-.156l-2.958-2.958a.688.688 0 01-.22-.53.806.806 0 01.24-.543.745.745 0 011.063.01l1.646 1.667V9.75c0-.213.071-.39.214-.534A.72.72 0 0112.495 9c.212 0 .39.072.536.216a.72.72 0 01.219.534v5.375l1.666-1.667a.733.733 0 011.063 0 .733.733 0 010 1.063l-2.958 2.958a.756.756 0 01-.525.208z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SwapIcon;
